export default "__VITE_ASSET__w4rYAcz0__"